import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fetchContact } from "@/lib/api";

export default function Footer() {
  const [contact, setContact] = useState(null);

  useEffect(() => {
    fetchContact().then(setContact).catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="relative bg-zinc-950 border-t border-zinc-900 mt-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <p className="text-[11px] uppercase tracking-[0.3em] text-zinc-500 mb-10">
          Let's talk
        </p>
        <a
          href={`mailto:${contact?.email || "Sharma.chinmaya12@gmail.com"}`}
          data-testid="footer-email-link"
          className="font-serif italic text-4xl md:text-6xl lg:text-7xl text-zinc-50 link-underline inline-block leading-none break-all"
        >
          {contact?.email || "Sharma.chinmaya12@gmail.com"}
        </a>

        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-12 border-t border-zinc-900 pt-12">
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
              Studio
            </p>
            <p className="text-zinc-300 text-sm leading-relaxed">
              {contact?.location || "India · Qissa Studios"}
            </p>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
              Production company
            </p>
            <a
              href="https://www.qissastudios.in/"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-qissa-link"
              className="text-zinc-300 text-sm leading-relaxed hover:text-white link-underline"
            >
              Qissa Studios
              <br />
              <span className="text-zinc-500">qissastudios.in</span>
            </a>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
              Elsewhere
            </p>
            <ul className="space-y-2">
              {(contact?.socials || []).map((s) => (
                <li key={s.label}>
                  <a
                    href={s.url}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="group text-zinc-300 text-sm inline-flex items-center gap-1.5 hover:text-white transition-colors"
                  >
                    {s.label}
                    <ArrowUpRight className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity" strokeWidth={1.5} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
              Site
            </p>
            <ul className="space-y-2">
              {[
                ["/", "Index"],
                ["/work", "Work"],
                ["/about", "About"],
                ["/contact", "Contact"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-link-${label.toLowerCase()}`}
                    className="text-zinc-300 text-sm hover:text-white transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.28em] text-zinc-600">
          <span>© {new Date().getFullYear()} Chinmaya Sharma · Qissa Studios</span>
          <span>I love the set, the sweat, and the storytelling.</span>
        </div>
      </div>
    </footer>
  );
}
